<template>
  <div id="zt8623">
    <div id="z1">
      <span v-if="$store.state.iscn">
        <div>ZT8623 人脸支付终端</div>
        <label>小机身高性能，聚合多种支付方式，方便快捷</label>
        <img :src="require('@/assets/pic/zt8623/bg1icon.png')" />
      </span>
      <span v-else>
        <h5>ZT8623</h5>
        <h5>Facial Payment Terminal</h5>
        <h5>Support facial, IC, Magnetic, NFC, QR etc.</h5>
      </span>
    </div>
    <div id="z2" v-if="$store.state.iscn">
      <label>ZT8623是一款智能人脸支付收银终端，产品通过人脸识别技术终端安全认证，符合银联卡受理终端安全规范。支持银联、微信、支付宝等主流人脸支付系统，可扩展非接触IC卡和扫码支付。</label>
    </div>
    <div id="z2_en" v-else>
      <img :src="require('@/assets/pic/zt8228/icon1.png')"/>
      <img :src="require('@/assets/pic/zt8228/icon2.png')"/>
      <img :src="require('@/assets/pic/zt8228/icon3.png')"/>
    </div>
    <div id="z3">
      <div>{{$t('lang.smlcba')}}</div>
      <label>{{$t('lang.bscmr')}} </label>
    </div>
    <div id="z4">
      <div>{{$t('lang.hlrtfu')}}</div>
      <label>{{$t('lang.udbigang')}}</label>
    </div>
    <payscene :data="sdata"></payscene>
    <pdpp :data="ppdata"></pdpp>
    <pdspecs :data="$store.state.iscn?spdata:spdata_en"></pdspecs>
  </div>
</template>

<script>
import payscene from '@/components/payscene'
import pdpp from '@/components/pdpp'
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    payscene,pdpp,pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    var mylang = localStorage.lang
    return {
      sdata: {
        title: mylang=='cn'?'':'Pay unbounded as you have ',
        data: [
          {
            pic: require('@/assets/pic/zt8623/s1.png'),
            label: _this.$t('lang.facepay')
          },
          {
            pic: require('@/assets/pic/zt8623/s2.png'),
            label: _this.$t('lang.scandv')
          },
          {
            pic: require('@/assets/pic/zt8623/s3.png'),
            label: _this.$t('lang.untcicc')
          },
        ]
      },
      ppdata: {
        title: mylang=='cn'?'':'Product performance and matching',
        desc: _this.$t('lang.camrtdsexp'),
        data: [
          {
            pic: require('@/assets/pic/zt8623/p1.png'),
            label: _this.$t('lang.stbmucam')
          },
          {
            pic: require('@/assets/pic/zt8623/p2.png'),
            label: _this.$t('lang.canrotds')
          },
          {
            pic: require('@/assets/pic/zt8623/p3.png'),
            label: _this.$t('lang.expstrong')
          }
        ]
      },
      spdata: {
        file: 'ZT8623',
        data: [
          {label: '处理器', desc: ['ARM八核2.0GHz高速处理器','4核Cortex-A73 + 4核Cortex-A53'],pic: 'cpu.png'},
          {label: '存储器', desc: ['2GB RAM + 16GB ROM'],pic: 'ram.png'},
          {label: '操作系统', desc: ['Android 9.0','证通安全操作系统（ZOS）'], pic: 'sys.png'},
          {label: '显示屏', desc: ['10.1英寸800×1280 LCD，带背光控制'], pic: 'disp.png'},

          {label: '触摸屏', desc: ['10.1英寸800×1280 LCD，带背光控制'],pic: 'touch.png'},
          {label: '人脸识别摄像头', desc: ['支持选配华捷艾米3D结构光或者云从红外双目摄像头；', '支持活体检测 ，支持扫码，通过BCTC人脸安全认证。'], pic: 'face.png'},
          {label: '扫码器', desc: ['支持QR Code ,EAN-13/UPC-A,UPC-E,EAN-8，Code 128，Code39，Interleaved 2of5等'], pic: 'scan.png'},
          {label: '非接IC读卡器', desc: ['支持ISO14443 Type A/B符合EMV 4.3和PBOC 3.0规范'], pic: 'utic.png'},
          {label: '密码键盘', desc: ['符合国密标准的金融密码键盘支持非接卡片读取'], pic: 'keyb.png'},
          {label: '有线网络', desc: ['标准：支持TCP/IP协议，10/100/1000Mbps 自适应'], pic: 'ethr.png'},
          {label: '移动网络', desc: ['支持 GSM / WCDMA / EVDO / TD-SCDMA /  TDD-LTE / FDD-LTE'], pic: 'mobi.png'},
          {label: 'WIFI', desc: ['支持IEEE 802.11 a / b / g / n / ac2.4G Hz + 5G Hz'], pic: 'wifi.png'},
          {label: '蓝牙', desc: ['支持蓝牙 4.0及以上 支持BLE'], pic: 'blt.png'},
          {label: '定位', desc: ['内置GPS / 北斗 / Glonass','支持LBS功能','支持AGPS'], pic: 'lbs.png'},
          {label: '金额键盘（选配）', desc: ['选配支持带数字回显功能的金额数字键盘'], pic: 'mkeyb.png'},
          {label: '接口', desc: ['USB×2、MicroUSB×1、RS232×1、RJ45×1、SIM×1、电源口×1'], pic: 'port.png'},
          {label: '适配器', desc: ['输入：AC 100~240V','输出：DC 12V/2A'], pic: 'char.png'},
          {label: '支架', desc: ['金属可升降支架，支持调节角度'], pic: 'brk.png'},
          {label: '适用环境', desc: ['工作温度： 0℃～+50℃ ','存储温度：-20℃～+70℃','相对湿度：10%～90% RH (不结露)'], pic: 'env.png'}
        ]
      },
      spdata_en: {
        file: 'ZT8623',
        data: [
          {label: 'Processor', desc: ['Quad core Cortex-A73@2.0Ghz','Quad core Cortex-A73@2.0Ghz'],pic: 'cpu.png'},
          {label: 'Memory', desc: ['2GB RAM+16GB ROM'],pic: 'ram.png'},
          {label: 'Os', desc: ['ZOS based on Android 9.0'], pic: 'sys.png'},
          {label: 'Display', desc: ['10.1"800×1280', 'With backlight control'], pic: 'disp.png'},
          {label: 'Touch Screen', desc: ['Capacitive touch screen', 'Handwriting input'],pic: 'touch.png'},
          {label: 'Scanner(optional)', desc: ['QR/ EAN-13/ UPC-A/ UPC-E/EAN-8 / Code 128/ Code39 / lnterleaved 2of5'], pic: 'scan.png'},
          {label: 'Contactless(optional)', desc: ['ISO14443 TypeA/B', 'EMV4.3', 'EMV4.3'], pic: 'utic.png'},
          {label: 'Encrypted Pinpad', desc: ['Financial encrypted pinpad', 'Contactless optional'], pic: 'keyb.png'},
          {label: 'Ethernet', desc: ['10/100/1000Mbps'], pic: 'ethr.png'},
          {label: 'Cellular Network', desc: ['GSM / WCDMA/ EVDO/TD-SCDMA/TDD-LTE/FDD-LTE'], pic: 'mobi.png'},
          {label: 'WIFI', desc: ['IEEE 802.11 a/ blg/n/ ac', '2.4G Hz＋5G Hz'], pic: 'wifi.png'},
          {label: 'Bluetooth', desc: ['Bluetooth 4.0 and above', 'BLE'], pic: 'blt.png'},
          {label: 'Location', desc: ['Built-in GPS/Beidou/Glonass','LBS','AGPS'], pic: 'lbs.png'},
          {label: 'Keypad(optional)', desc: ['Physical keys x 12', 'Display x 1'], pic: 'mkeyb.png'},
          {label: 'Port', desc: ['USBx2、MicroUSBx1、RS232×1', 'RJ45×1、SIM×1、Powerx1'], pic: 'port.png'},
          {label: 'Adapter', desc: ['lnput: AC 100-240V','Output: DC12V/2A'], pic: 'char.png'},
          {label: 'Bracket', desc: ['Metal lifting bracket (Rotatable)'], pic: 'brk.png'},
          {label: 'Environment', desc: ['Working temp: 0℃~+50℃','Storage temp: -20℃~+70℃','Relative humidity : 10%~90%RH(non-condensing)'], pic: 'env.png'}
        ]
      }
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zt8623 {
  background: white;
  margin-top: -.93rem;
}
#z1 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8623/bg1.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 4.27rem;
}
#z1 div {
  margin-top: 2.37rem;
  font-size: .48rem;
  font-weight: bold;
  color: #4D4B49;
}
#z1 label {
  display: block;
  font-size: .3rem;
  font-weight: 400;
  color: #4D4D4D;
  margin-top: .09rem;
  margin-bottom: .36rem;
}
#z1 img {
  width: 3.5rem;
}
#z1 h5 {
  font-size: .55rem;
  font-weight: 800;
  color: #666666;
  margin: 0;
  padding: 0;
}
#z1 h5:nth-child(1) {
  margin-top: 2.4rem;
}
#z1 h5:nth-child(3) {
  margin-top: .1rem;
  font-size: .36rem;
  font-weight: 500;
  color: #7E7E7F;
  width: 5.7rem;
}

#z2 {
  background: #B7B6B6;
  height: 1.78rem;
}
#z2 label{
  display: block;
  font-size: .24rem;
  font-weight: 400;
  color: #FFFFFF;
  text-align: center;
  padding: .45rem 4.07rem .48rem 4.07rem;
  line-height: .48rem;
  
}
#z2_en {
  height: 1.78rem;
  text-align: center;
  background: #EAEAEA;
}
#z2_en img {
  /* height: .42rem; */
  margin: .69rem .12rem 0 .12rem;
}

#z3 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8623/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 9.52rem;
}
#z3 div {
  margin: 2.81rem 0 .2rem 0;
  font-size: .6rem;
  font-weight: bold;
  color: #4D4D4D;
}
#z3 label {
  font-size: .24rem;
  font-weight: 400;
  color: #4D4D4D;
  margin-left: .05rem;
}

#z4 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8623/bg3.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.72rem;
  color: #4D4D4D;
}
#z4 div {
  margin-top: 3.4rem;
  margin-bottom: .18rem;
  font-size: .6rem;
  font-weight: bold;
}
#z4 label {
  font-size: .24rem;
  font-weight: 400;
}

</style>
